module.exports = __webpack_public_path__ + "static/media/index-ad-img4.8cfa36ab.jpg";